import {makeAutoObservable} from 'mobx';
import s from '../../s';
import axios from 'axios';

declare var __fiu: string;

interface IImageResult {
    hash: string;
    w: number;
    h: number;
}

class ImageUploadStore {
    public file: File;
    public reso_level: number = 0;

    constructor() {
        makeAutoObservable(this);
    }

    uploadImage = async () => {
        try {
            s.ui.image_uploading = true;
            s.ui.image_uploaded_msg = '';
            s.ui.processing_title = 'Image Uploading';
            s.ui.processing_text = 'Please stay on this page until your image is done uploading.';
            // console.log('file bytes length', this.file.size);

            const url = '/api/img/event';
            const formData = new FormData();

            formData.append('file', this.file);
            formData.append('fileName', this.file.name);
            formData.append('doc_width', s.pcs.docWidth.toString());
            formData.append('doc_height', s.pcs.docHeight.toString());
            formData.append('fiu', __fiu);

            // console.error(formData);

            const token: HTMLInputElement | null = document.querySelector('input[name="__RequestVerificationToken"]');

            const config = {
                headers: {
                    RequestVerificationToken: token?.value,
                },
            };

            const response = await axios.post(url, formData, config);
            const ir: IImageResult = response.data;

            if (!ir.hash || ir.hash?.includes('error') || ir.hash?.length !== 32) {
                // console.error('image upload failed', ir.hash ? ir.hash : 'empty');
                this.imageUploadError();
            } else {
                // console.error('image upload success', ir.hash);
                s.ui.image_uploaded_msg = '';
                s.pcs.image_upload_hash3 = ir.hash;
                s.pcs.override_d1_img = `https://chc-upload.s3.amazonaws.com/d/${ir.hash}.png`;
                s.ui.image_uploaded = true;
                s.ui.doRender = true;
                s.ui.update_pricing = true;
            }
        } catch (err) {
            console.error(err);
            s.ui.image_uploading = false;
            s.pcs.override_d1_img = '';
            this.cancel();
        } finally {
            s.ui.image_uploading = false;
        }
    };

    imageUploadError = () => {
        s.ui.image_uploaded = false;
        s.ui.image_uploaded_msg = 'Error uploading image. Please try again or contact customer service.';
        this.reso_level = 0;
        this.cancel();
    };

    cancel = () => {
        const fileInput: HTMLInputElement | null = document.querySelector('#imageUploadInput');

        if (fileInput) {
            fileInput.value = '';
        }
    };
}

export const imageUploadStore = new ImageUploadStore();
